import React, { useState, useEffect } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { toast } from "sonner";
import AuthShell from "../components/AuthShell";
import { Button, Input } from "../components/ui";
import Icon from "../components/Icon";
import { useAuth } from "../context/AuthContext";
import { apiError } from "../lib/api";

const DEMO_EMAIL = "demo@choremouse.app";
const DEMO_PASSWORD = "LetsClean";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.has("demo")) {
      setEmail(DEMO_EMAIL);
      setPassword(DEMO_PASSWORD);
    }
  }, [location.search]);

  const submit = async (e, demo) => {
    e?.preventDefault();
    setLoading(true);
    const loginEmail = demo ? DEMO_EMAIL : email;
    const loginPassword = demo ? DEMO_PASSWORD : password;
    if (demo) {
      setEmail(DEMO_EMAIL);
      setPassword(DEMO_PASSWORD);
    }
    try {
      const u = await login(loginEmail, loginPassword);
      toast.success(demo ? "Welcome to the demo family!" : "Welcome back!");
      navigate(u?.role === "admin" ? "/admin" : "/app");
    } catch (err) {
      toast.error(apiError(err));
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Welcome back" subtitle="Sign in to manage your family."
      footer={<>New here? <Link to="/register" className="text-primary font-bold" data-testid="link-register">Create an account</Link></>}>
      <form onSubmit={(e) => submit(e, false)} className="space-y-4" data-testid="login-form">
        <Input label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
          placeholder="you@example.com" required data-testid="login-email" />
        <Input label="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
          placeholder="••••••••" required data-testid="login-password" />
        <div className="text-right -mt-1">
          <Link to="/forgot-password" className="text-sm font-bold text-ink-soft hover:text-primary" data-testid="link-forgot">Forgot password?</Link>
        </div>
        <Button type="submit" size="lg" className="w-full" disabled={loading} data-testid="login-submit">
          {loading ? "Signing in…" : "Sign in"}
        </Button>
      </form>

      <div className="flex items-center gap-3 my-6">
        <div className="h-px bg-slate-200 flex-1" /><span className="text-xs font-bold text-ink-muted uppercase tracking-widest">or</span><div className="h-px bg-slate-200 flex-1" />
      </div>
      <Button variant="sunny" size="lg" className="w-full" onClick={(e) => submit(e, true)} disabled={loading} data-testid="login-demo">
        <Icon name="play" width={18} height={18} /> Explore the live demo
      </Button>
      <button onClick={() => navigate("/kids")} data-testid="login-kids-door"
        className="mt-5 w-full inline-flex items-center justify-center gap-2 text-primary-dark font-bold hover:gap-3 transition-all">
        <Icon name="door-open" width={18} height={18} /> Kids door →
      </button>
    </AuthShell>
  );
}
